/**
 * Regex to check cd field
 * @type {RegExp}
 */

const cd = /^[A-Z0-9]{7}$/

export default cd
